/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PropertyDiagnosticsResponse,
} from '../models/index';
import {
    PropertyDiagnosticsResponseFromJSON,
    PropertyDiagnosticsResponseToJSON,
} from '../models/index';

export interface DiagnosticsPropertyHotelIdGetRequest {
    hotelId: number;
}

/**
 * 
 */
export class DiagnosticsApi extends runtime.BaseAPI {

    /**
     * Get property metadata, supplier mappings, and recent rate fetch activity for diagnostics.
     */
    async diagnosticsPropertyHotelIdGetRaw(requestParameters: DiagnosticsPropertyHotelIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PropertyDiagnosticsResponse>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling diagnosticsPropertyHotelIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/diagnostics/property/{hotel_id}`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PropertyDiagnosticsResponseFromJSON(jsonValue));
    }

    /**
     * Get property metadata, supplier mappings, and recent rate fetch activity for diagnostics.
     */
    async diagnosticsPropertyHotelIdGet(requestParameters: DiagnosticsPropertyHotelIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PropertyDiagnosticsResponse> {
        const response = await this.diagnosticsPropertyHotelIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
